// @ts-strict-ignore
import { ProductType } from '@/shared/types/product'

import { TCartItem } from '../types/cart-item'

import { isServiceHasProduct } from './isServiceHasProduct'

/**
 * Calculates the total number of products in the basket ()
 * @param cartItems - Products in the cart
 * @param includingServices - Should the selected services be taken into account in the calculation
 */
export const getCartCount = (cartItems: TCartItem[] = [], includingServices?: boolean): number => {
	cartItems = cartItems.filter(item => item.TYPE_PRODUCTS !== ProductType.TradeIn)

	const filteredCartItems = includingServices
		? cartItems
		: cartItems.filter(item => item.TYPE_PRODUCTS !== ProductType.Service)

	return filteredCartItems.reduce((cartCount, current) => {
		const { QUANTITY, TYPE_PRODUCTS, RELATED_PRODUCTS } = current
		let quantity = QUANTITY

		if (TYPE_PRODUCTS === ProductType.Service && !isServiceHasProduct(cartItems, RELATED_PRODUCTS)) {
			quantity = 0
		}
		// eslint-disable-next-line @typescript-eslint/ban-ts-comment
		// @ts-ignore
		return cartCount + quantity
	}, 0)
}
